"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserCompanies {
}
exports.UserCompanies = UserCompanies;
//# sourceMappingURL=UserCompanies.js.map